module.exports = __webpack_public_path__ + "static/media/tryzub.49abf7ab.svg";